import React, { useEffect, useState } from "react";
import Spinner from "../../components/_common/Spinner";

export interface InputProps {
  data: any,
  isloading: Boolean;
 
}

const SystemInfo = ({  data, isloading}: InputProps) => {
  useEffect(() => {

  }, [])
 
 
  return (
    <div className="tab-content-padding">

      {isloading === false && (
        <>
        <div className="row">
            <div className="col-md-3">
                باقیمانده پیامک:
            </div>
            <div className="col-md-3">
                <p className="system-info-cell">{data[0].SMSRemind} تومان</p>
            </div>
            <div className="col-md-3">
                نسخه نامنطبق:
            </div>
            <div className="col-md-3 ">
                 <p className="system-info-cell">{data[0].CoincidentVersion}</p>
            </div>
        </div>
         <div className="row">
         <div className="col-md-3">
              آخرین بکاپ:
         </div>
         <div className="col-md-3 ">
             <p className="system-info-cell">{data[0].LastBackup}</p>
         </div>
         <div className="col-md-3">
             حجم HDD:
         </div>
         <div className="col-md-3 ">
              <p className="system-info-cell">{data[0].DriveCapacity}</p>
         </div>
        </div>
         <div className="row">
      <div className="col-md-3">
          آخرین پیامک:
      </div>
      <div className="col-md-3 ">
          <p className="system-info-cell">{data[0].LastSMS}</p>
      </div>
      <div className="col-md-3">
          آخرین تلگرام:
      </div>
      <div className="col-md-3 ">
           <p className="system-info-cell">{data[0].LastTelegram}</p>
      </div>
        </div>
  </>
      )}

      {isloading === true && (
        <Spinner />
      )}

    </div>
  )

};

export default SystemInfo;
